/**
 * @file Float Cta.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Float Cta component.
 */
const vFloatCta = () => {
	const floatCta = document.querySelector('.v-float-cta');

	if (!floatCta) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const inner = floatCta.querySelector('.v-float-cta__inner');
	const images = floatCta.querySelectorAll('.v-float-cta__image');
	const cta = floatCta.querySelector('.v-float-cta__cta');
	const title = floatCta.querySelector('.v-float-cta__title');

	ScrollTrigger.saveStyles([...images, title]);

	ScrollTrigger.matchMedia({
		'(min-width: 1025px)': () => {
			gsap.timeline({
				defaults: {
					ease:     'sine.out',
					duration: 1,
				},
				scrollTrigger: {
					trigger: inner,
					start:   'top bottom',
					end:     'center center',
					scrub:   true,
				},
			})
				.fromTo(images, {
					xPercent: (i) => 60 + (i * -15),
				}, {
					xPercent: 0,
				})
				.fromTo(cta, { '--clip': 1 }, {
					'--clip': 0,
					duration: 0.7,
				}, '<+.3')
				.fromTo(title, { yPercent: 100, y: 20, opacity: 0 }, {
					yPercent: 0,
					y:        0,
					opacity:  1,
					duration: 0.35,
				}, '>-.35');
		},
	});

	let ctaDescend;

	/**
	 * Initialize the CTA descend animation.
	 */
	const initCtaDescend = () => {
		const target = inner.offsetHeight - cta.offsetHeight;
		ctaDescend = gsap.fromTo(cta, { y: 0 }, {
			y:             target,
			ease:          'sine.inOut',
			scrollTrigger: {
				trigger: inner,
				start:   'top bottom',
				end:     'bottom top',
				scrub:   true,
			},
		});
	};
	initCtaDescend();

	window.addEventListener('resize', () => {
		if (ctaDescend) {
			if (ctaDescend.scrollTrigger) {
				ctaDescend.scrollTrigger.kill();
			}

			ctaDescend.kill();
		}

		initCtaDescend();
	});
};

export default vFloatCta;
